module.exports = __webpack_public_path__ + "static/hearteyes-4eefe2e95630a43391ff72465d9222e3.gif";